import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

// service
import authService from 'core/services/auth';
import { getProfile } from 'core/services/profile';

//components
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import logo from 'assets/images/logo.svg';
import MainLoadingComponent from 'components/mainLoadingComponent/loadingComponent';

const AuthGuard = ({ children }: any) => {
	const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

	useEffect(() => {
		const checkAuth = async () => {
			if (!authService.isAuthenticated()) {
				setIsAuthenticated(false);
			} else {
				if (authService.getUser()) {
					setIsAuthenticated(true);
				} else {
					try {
						const response = await getProfile();
						const profile = response.data.data;
						authService.setUser(profile);
						authService.setPermissions(profile.permissions);
						authService.setRoles(profile.roles);
						setIsAuthenticated(true);
					} catch (error) {
						console.error('Failed to fetch profile:', error);
						setIsAuthenticated(false);
					}
				}
			}
		};

		checkAuth();
	}, []);

	// If still loading, you can show a loading indicator
	if (isAuthenticated === null) {
		return <MainLoadingComponent />;
	}

	// If not authenticated, redirect to login
	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	// If authenticated, render the children
	return <>{children}</>;
};

export default AuthGuard;
